<template>
    <v-row class="fill-height">
        <v-col
            class="pa-0"
            :cols="$vuetify.breakpoint.mdAndDown ? 12 : 4">
            <v-card
                class="col-login-left"
                flat
                tile
                dark>
                <v-img
                    contain
                    class="my-5"
                    max-height="25px"
                    src="/img/logo.png" />

                <v-form
                    style="width: 80%;"
                    ref="form"
                    @submit.prevent="submit"
                    v-model="valid"
                    method="post">
                    <v-card-title class="font-weight-bold">
                        Sign In
                    </v-card-title>

                    <v-card-text>
                        <v-text-field
                            outlined
                            name="email"
                            label="Email"
                            type="email"
                            v-model="email"
                            :rules="rules.email"
                            required />

                        <v-text-field
                            outlined
                            name="password"
                            label="Password"
                            v-model="password"
                            :rules="rules.password"
                            hide-details="auto"
                            :append-icon="show_password ? 'mdi-eye primary--text' : 'mdi-eye-off'"
                            @click:append="() => (show_password = !show_password)"
                            :type="!show_password ? 'password' : 'text'"
                            required />
                    </v-card-text>

                    <v-card-actions class="px-4">
                        <v-btn
                            :disabled="!valid"
                            :loading="loading"
                            block
                            dark
                            type="submit">
                            Sign In
                        </v-btn>
                    </v-card-actions>

                    <v-card-actions class="px-4">
                        <router-link
                            :to="{name: 'forgot-password'}"
                            class="white--text font-weight-bold caption">
                            Forgot Password?
                        </router-link>

                        <v-spacer />

                        <router-link
                            :to="{name: 'register'}"
                            class="white--text font-weight-bold caption">
                            Sign Up
                        </router-link>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-col>

        <v-col
            class="col-login-right"
            v-if="$vuetify.breakpoint.lgAndUp"
            :cols="8">
            <v-row>
                <v-col
                    cols="12"
                >
                    <v-skeleton-loader
                        :aria-busy="false"
                        type="card-avatar, article, actions"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
    data() {
        return {
            loading: false,
            valid: false,
            email: '',
            password: '',
            show_password: false,
            rules: {
                email: [
                    v => (new Validation(this)).ruleRequired(v, 'Email'),
                    v => (new Validation(this)).ruleEmail(v, 'Email')
                ],
                password: [
                    v => (new Validation(this)).ruleRequired(v, 'Password')
                ],
            }
        };
    },

    computed: {
        ...mapGetters({
            authenticated: 'auth/authenticated',
        }),
    },

    mounted() {
        if (this.$route.query['email-verified'] !== undefined) {
            if (this.$route.query['email-verified']) {
                (new SuccessAlert(this)).simple('Your email successfully verified.');
            } else {
                (new ErrorAlert(this)).simple('Something Went Wrong, Please Try Again.');
            }

            this.$router.push(this.$route.path);
        }
    },

    methods: {
        ...mapActions({
            logIn: 'auth/logIn',
            sendVerificationLink: 'auth/sendVerificationLink'
        }),

        submit() {
            if (!this.$refs.form.validate()) return;

            this.loading = true;

            let credentials = {
                email: this.email,
                password: this.password,
            };

            this
                .logIn(credentials)
                .then(() => {
                    this.$router.replace({name: 'home'});
                })
                .catch((error) => {
                    let alert;

                    if (error.response.data.errors && error.response.data.errors.reason) {
                        alert = (new WarningAlert(this)).setMessage(error.response.data.message);

                        alert.hasAction();
                        alert.setActionText('Send link again');
                        alert.setAction(() => {
                            this.sendVerificationLink(this.email).then(response => {
                                (new SuccessAlert(this)).setMessage(response.data.message).show();
                            });
                        });
                    } else {
                        alert = (new ErrorAlert(this)).setMessage(error.response.data.message);
                    }

                    alert.show();
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
